// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const solrock: PokeData = {
  "id": 338,
  "name": "solrock",
  "height": 12,
  "weight": 1540,
  "base_experience": 161,
  "types": [
    PokeType.ROCK,
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "tackle",
    "solar-beam",
    "fire-spin",
    "rock-throw",
    "confusion",
    "psychic",
    "hypnosis",
    "harden",
    "psywave",
    "explosion",
    "rock-slide",
    "morning-sun",
    "cosmic-power",
    "embargo",
    "heal-block",
    "flare-blitz",
    "rock-polish",
    "zen-headbutt",
    "stone-edge",
    "wonder-room"
  ],
  "moves": [
    "tackle",
    "solar-beam",
    "fire-spin",
    "rock-throw",
    "psychic",
    "psywave",
    "rock-slide",
    "morning-sun",
    "flare-blitz",
    "zen-headbutt",
    "psychic-terrain",
    "psy-ball",
    "reflect"
  ],
  "evolution_chain": {
    "id": 172,
    "item": null,
    "species": [
      {
        "name": "solrock",
        "order": 366,
        "types": [
          PokeType.ROCK,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 133,
    "speed": 113,
    "ability_power": 154
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
